/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_bug_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happened, what did you expect, and how can we reproduce it?`)
};

const es_contact_bug_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué ocurrió, qué esperabas y cómo podemos reproducirlo?`)
};

const de_contact_bug_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist passiert, was hast du erwartet und wie können wir es reproduzieren?`)
};

const nl_contact_bug_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat gebeurde er, wat verwachtte je en hoe kunnen we het reproduceren?`)
};

const fr_contact_bug_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que s'est-il passé, à quoi vous attendiez-vous et comment pouvons-nous le reproduire ?`)
};

const it_contact_bug_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa è successo, cosa ti aspettavi e come possiamo riprodurlo?`)
};

const pt_br2_contact_bug_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que aconteceu, o que você esperava e como podemos reproduzir?`)
};

const pt_contact_bug_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que aconteceu, o que esperavas e como podemos reproduzi-lo?`)
};

const ja_contact_bug_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何が起きましたか、何を期待していましたか、どうすれば再現できますか？`)
};

const zh_contact_bug_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发生了什么？你期望的结果是什么？我们如何复现？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_bug_body_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_bug_body_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_bug_body_hint", locale)
	if (locale === "en") return en_contact_bug_body_hint(inputs)
	if (locale === "es") return es_contact_bug_body_hint(inputs)
	if (locale === "de") return de_contact_bug_body_hint(inputs)
	if (locale === "nl") return nl_contact_bug_body_hint(inputs)
	if (locale === "fr") return fr_contact_bug_body_hint(inputs)
	if (locale === "it") return it_contact_bug_body_hint(inputs)
	if (locale === "pt-BR") return pt_br2_contact_bug_body_hint(inputs)
	if (locale === "pt") return pt_contact_bug_body_hint(inputs)
	if (locale === "ja") return ja_contact_bug_body_hint(inputs)
	return zh_contact_bug_body_hint(inputs)
};